import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/common/PageHeader';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons';

const Dashboard = () => {
  const { t } = useTranslation();
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    const storedName = localStorage.getItem('displayName');
    if (storedName) {
      setDisplayName(storedName);
    }
  }, []);

  return (
    <>
      <PageHeader 
        title={t('dashboard.title')}
        subtitle={t('dashboard.subtitle')}
        icon={faTachometerAlt}
      />
      <section className="panel">
        <div className="panel-body">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', padding: '50px 0' }}>
                <h1 className="text-primary" style={{ fontSize: '3em', marginBottom: '20px' }}>
                  {t('dashboard.welcome', { name: displayName || 'Usuario' })}
                </h1>
                <p className="text-muted" style={{ fontSize: '1.2em' }}>
                  {t('dashboard.welcomeMessage')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
